import { deleteFirebaseToken } from "notifications/firebase";
import React, { Component } from "react";
import { Navbar, Collapse } from "react-bootstrap";
import { withRouter } from "react-router-dom";

class LogOutIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      username: "",
      userrole: "",
    };
    this.logout = this.logout.bind(this);
    this.wrapperRef = React.createRef();
  }
  componentDidMount() {
    if (
      localStorage.getItem("user") == null ||
      localStorage.getItem("user") == ""
    ) {
      window.location.href = "/auth/login-page";
    } else {
      var token = JSON.parse(localStorage.getItem("user"));
      const username = token.name;
      this.setState({
        username: username,
        userrole: token.role,
      });
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ openAvatar: false });
    }
  };
  handleAvatarClick = (e) => {
    e.preventDefault();
    this.setState((prev) => ({ openAvatar: !prev.openAvatar }));
  };

  async logout() {
    localStorage.removeItem("user");
    await deleteFirebaseToken();
    this.props.history.push("/auth/login-page");
  }

  render() {
    const user_role_arr = {
      1: "Super Admin",
      2: "Admin",
      3: "User",
      4: "Third Party",
      5: "Rider",
      6: "Lab Partner",
      7: "Lab Rider",
      8: "Supplier",
      9: "Doctor",
      10: "Courier Partner",
      11: "Pharmacist",
      12: "Partner",
      13: "Procurement",
      14: "Insurance",
      15: "Insurance Ref",
      16: "Reviewer",
      17: "Store Manager",
      18: "Store Phamasist",
      19: "Customer Service",
    };

    return (
      <Navbar.Collapse>
        <div
          style={{ float: "right", position: "relative" }}
          ref={this.wrapperRef}
        >
          {/* Avatar */}
          <img
            src="https://flash-prod.s3.ap-south-1.amazonaws.com/adminNewImage/avatar_icon.png"
            alt="avatar"
            style={{ width: 32, margin: 13, cursor: "pointer" }}
            onClick={this.handleAvatarClick}
          />

          {/* Role label */}
          <span
            style={{
              verticalAlign: "sub",
              fontWeight: 600,
              fontFamily: "inherit",
              cursor: "pointer",
            }}
            onClick={this.handleAvatarClick}
          >
            {user_role_arr[this.state.userrole]}
          </span>

          {/* Pop profile card */}
          <Collapse in={this.state.openAvatar}>
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 66,
                width: 206,
                background: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                borderRadius: 6,
                padding: "11px 14px",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <img
                  src="https://flash-prod.s3.ap-south-1.amazonaws.com/adminNewImage/avatar_icon.png"
                  alt="avatar"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    marginRight: 10,
                  }}
                />
                <div>
                  <div style={{ fontWeight: 600 }}>{this.state.username}</div>
                  <div style={{ fontSize: 13, color: "#555" }}>
                    {/* {this.state.email} */}
                  </div>
                </div>
              </div>
              <hr style={{ margin: "8px 0" }} />
              <button className="logoutBtn" type="button" onClick={this.logout}>
                Log out
              </button>
            </div>
          </Collapse>
        </div>
      </Navbar.Collapse>
    );
  }
}

export default withRouter(LogOutIcon);
